// extracted by mini-css-extract-plugin
export var page = "mainlayout-module--page--1EGdC";
export var mainContainerDiv = "mainlayout-module--mainContainerDiv--2iWhD";
export var headerRow = "mainlayout-module--headerRow--2oT4t";
export var logoImg = "mainlayout-module--logoImg--2iyfN";
export var headerLeftCol = "mainlayout-module--headerLeftCol--2rjyN";
export var headerRightCol = "mainlayout-module--headerRightCol--3YtaB";
export var welcomeCol = "mainlayout-module--welcomeCol--3_k3r";
export var welcomeVidCol = "mainlayout-module--welcomeVidCol--3bHm8";
export var comingSoon = "mainlayout-module--comingSoon--3Bqmb";
export var card = "mainlayout-module--card--3LpUZ";
export var cardImg = "mainlayout-module--cardImg--1M9Dq";
export var cardTitle = "mainlayout-module--cardTitle--3Dria";
export var codeForm = "mainlayout-module--codeForm--17uqj";
export var codeInput = "mainlayout-module--codeInput--16Wha";
export var protectedRow = "mainlayout-module--protectedRow--TemtD";
export var protectedColDiv = "mainlayout-module--protectedColDiv--PCbmU";
export var lockedRow = "mainlayout-module--lockedRow--ZHSJF";
export var applyContainer = "mainlayout-module--applyContainer--1gFjT";
export var applyCol = "mainlayout-module--applyCol--1IfOt";
export var applyColDiv = "mainlayout-module--applyColDiv--tWofd";
export var infoContainer = "mainlayout-module--infoContainer--2YzwZ";
export var infoCol = "mainlayout-module--infoCol--m5By1";
export var infoColDiv = "mainlayout-module--infoColDiv--3vzR2";